// ../componente/UserDetailsModal.jsx
import React from "react";

const UserDetailsModal = ({ userDetails, onClose }) => {
  return (
    <div className="modal">
      <div className="modal-content">
        <span className="close" onClick={onClose}>&times;</span>
        <h2>Detalii Utilizator</h2>
        <div style={{ textAlign: "center", marginBottom: "15px" }}>
          {userDetails.fotografie || userDetails.avatar_url ? (
            <img
              src={userDetails.fotografie || userDetails.avatar_url}
              alt="Fotografie utilizator"
              style={{ width: "120px", height: "120px", borderRadius: "50%", objectFit: "cover" }}
            />
          ) : (
            <div
              style={{
                width: "120px",
                height: "120px",
                borderRadius: "50%",
                backgroundColor: "#ccc",
                display: "inline-block",
                lineHeight: "120px",
                color: "#666",
                fontSize: "14px"
              }}
            >
              Fără fotografie
            </div>
          )}
        </div>
        <div>
          <p><strong>Nume:</strong> {userDetails.nume}</p>
          <p><strong>Prenume:</strong> {userDetails.prenume}</p>
          <p><strong>Instituție:</strong> {userDetails.institutie}</p>
          <p><strong>Funcție:</strong> {userDetails.functie}</p>
          <p><strong>Nr. de telefon:</strong> {userDetails.telefon}</p>
          <p><strong>E-mail:</strong> {userDetails.email}</p>
        </div>
      </div>
    </div>
  );
};

export default UserDetailsModal;
